'use strict';

var i18n = require('utils/i18n');

var HelpDialogView = Backbone.Marionette.ItemView.extend({
    template: require('components/common/templates/help'),

    ui: {
        start: '#js-start',
    },

    events: {
        'click @ui.start': 'startTour',
    },

    initialize: function (options) {
        this.guide = options.guide;
        this.tourOptions = options.options;
        this.title = options.title;
        this.text = options.text;

        // check if at least one element of the help tour is visible
        this.hasSteps = _.find($(options.guide.steps), function (element, index, list) {
            return $(element.target).is(':visible');
        });
        this.closeTourText = this.hasSteps ? i18n.TR('Später') : i18n.TR('Schließen');
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.text = this.text;
        data.title = this.title;
        data.hasSteps = this.hasSteps;
        data.closeTourText = this.closeTourText;

        return data;
    },

    startTour: function () {
        $.pageguide(this.guide, { closeText: i18n.TR('schließen') });
        $.pageguide('load', this.guide, this.tourOptions);
        $.pageguide('open');
        $('.pageguide-step.expanded').css('z-index', '+=1000');
    },
});

module.exports = HelpDialogView;
